export default "__VITE_ASSET__BvwMy3i7__"